import { render, staticRenderFns } from "./Factura.vue?vue&type=template&id=7be0eab8"
import script from "./Factura.vue?vue&type=script&lang=js"
export * from "./Factura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports